import React from 'react';
import { MainLayout } from '@components';
import AllergiesComponents from './Allergies';

export default function AllergiesPage(props) {
  return (
    <MainLayout footer="main" children={<AllergiesComponents {...props} />} />
  );
}
